<template>
    <div class="mb-5 w-full">
        <div class="mb-5 mr-4 pb-2 flex justify-between border-b border-gray-300">
            <h1 class="flex-1 module-header text-2xl">CityStat Projects</h1>
            <a class="ml-5 btn btn-small btn-blue" href="/sites/create">
                <div class="flex items-center justify-center space-x-2">
                    <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                    <p class="text-white">New CityStat Project</p>
                </div>
            </a>
        </div>
        <table v-if="cityStatProjects.length" class="min-w-[350px]">
            <thead class="cursor-pointer">
            <tr>
                <th class="pl-4">Name</th>
                <th class="text-right"># Cities</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="cityStatProject in cityStatProjects" :key="cityStatProject.id">
                <td class="pl-4">
                    <button @click="selectedCityStatProject = cityStatProject.id">
                        {{ cityStatProject.label ?? 'CityStat Project' }}
                    </button>
                </td>
                <td class="text-right">{{ cityStatProject.cities_count }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: {
            cityStatProjects: {
                type: [Array, Object],
                required: true
            }
        }
    };
</script>
